module.exports = __webpack_public_path__ + "static/media/20ECE20.4c996c7e.jpg";